import { ExtendedDosageFormController } from '../ExtendedDosageForm.types';

import { DosagePeriodAmountSteps } from './DosagePeriodField.types';
import { getMultipleSteps } from './DosagePeriodField.utils';
import { createStageFieldNameFactory } from './StageFieldList.utils';

type UseTimesOfDayDurationAmountStepsOptions = Pick<ExtendedDosageFormController, 'watch'> & {
   index: number;
   administrationIntervalDaysDefaultValue: number;
};

export const useTimesOfDayDurationAmountSteps = (
   options: UseTimesOfDayDurationAmountStepsOptions
): DosagePeriodAmountSteps => {
   const createFieldName = createStageFieldNameFactory(options.index);
   const administrationIntervalDays = Number(
      options.watch(createFieldName('administrationIntervalDays')) ?? options.administrationIntervalDaysDefaultValue
   );

   return getMultipleSteps(administrationIntervalDays);
};
